import yup from 'yup';
// translate
import messages from './messages';

export default yup.object({
  swift: yup.string().required(messages.validationRequiredField),
  iban: yup.string().required(messages.validationRequiredField),
  bankName: yup.string().required(messages.validationRequiredField),
  country: yup.string().required(messages.validationRequiredField),
  accountOwner: yup.string().required(messages.validationRequiredField),
});



// WEBPACK FOOTER //
// ./src/containers/PaymentInfo/formRules.js